import { useEffect } from 'react';

import axios from 'axios';
import ErrorState from 'components/layout/error-state/error-state';
import LoadingOlist from 'components/layout/loading-olist';
import LeadsHeader from 'pages/leads/components/leads-header/leads-header';
import { QualificationContext } from 'pages/leads/components/qualification-context';
import SegmentsContainer from 'pages/leads/components/segments/segments-container/segments-container';
import { API_URLS } from 'pages/leads/constants';
import { useAsyncFn } from 'react-use';

import { Container } from '@olist/templates';
import { Flex } from '@olist/united';

const SegmentsPage = () => {
  const [{ error, loading, value: qualificationResponse }, fetchQualificationData] =
    useAsyncFn(async () => {
      return axios.get(API_URLS.getCategories);
    }, []);

  useEffect(() => {
    fetchQualificationData();
  }, [fetchQualificationData]);

  if (error) {
    return (
      <Flex height="100vh" justifyContent="center" alignItems="center">
        <ErrorState onClick={() => window.location.reload()} />
      </Flex>
    );
  }

  if (loading || !qualificationResponse) {
    return <LoadingOlist data-testid="qualification-loading-olist" />;
  }

  return (
    <QualificationContext.Provider
      value={{
        categories: [...qualificationResponse.data],
      }}
    >
      <Container>
        <LeadsHeader currentStep={LeadsHeader.steps.REQUIREMENTS} />
        <Flex alignItems="left" flexDirection="column" mt={2} mx={1}>
          <SegmentsContainer />
        </Flex>
      </Container>
    </QualificationContext.Provider>
  );
};

export default SegmentsPage;
